import { render } from "./TopDestinationsView.vue?vue&type=template&id=7a03641b"
import script from "./TopDestinationsView.vue?vue&type=script&lang=js"
export * from "./TopDestinationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__